<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
          <!--            <a-form-item label="学生姓名">-->
          <!--              <a-input placeholder="请输入学生姓名" v-model="queryParam.id"></a-input>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :span="6">
            <a-form-item label="家长姓名">
              <a-input placeholder="请输入家长姓名" v-model="queryParam.realNameLike"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="付费状态">
              <j-dict-select-tag
                v-model="queryParam.feeStatus"
                placeholder="请选择付费状态"
                dictCode="fee_status"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">
                重置
              </a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('school_user_info')">
        导出
      </a-button>
      <a-upload
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel"
      >
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
        项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            :preview="record.id"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)"
          >
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <school-user-info-modal ref="modalForm" @ok="modalFormOk"></school-user-info-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import SchoolUserInfoModal from './modules/SchoolUserInfoModal'
import { initDictOptions, filterDictText } from '@/components/dict/JDictSelectUtil'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import UpdateStudentFaceModal from '../studentInfo/modules/UpdateStudentFaceModal'

export default {
  name: 'SchoolUserInfoList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    SchoolUserInfoModal,
    // JDictSelectTag,
    filterDictText,
    UpdateStudentFaceModal,
    JSearchSelectTag,
  },
  data() {
    return {
      description: 'school_user_info管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '家长姓名',
          align: 'center',
          dataIndex: 'sysUser.realname',
        },
        {
          title: '家长id',
          align: 'center',
          dataIndex: 'id',
        },
        {
          title: '签名授权',
          align: 'center',
          dataIndex: 'authFlag_dictText',
        },
        {
          title: '签名时间',
          align: 'center',
          dataIndex: 'authTime',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          title: '签名图片',
          align: 'center',
          dataIndex: 'authSign',
          scopedSlots: { customRender: 'imgSlot' },
        },
        {
          title: '在校瞬间授权',
          align: 'center',
          dataIndex: 'empower_dictText',
        },
        {
          title: '消息推送授权',
          align: 'center',
          dataIndex: 'receive_dictText',
        },
        {
          title: '租户id',
          align: 'center',
          dataIndex: 'tenantId',
        },
        {
          title: '试用期限',
          align: 'center',
          dataIndex: 'limitTime',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          title: '付费状态(0.未付费 1.已付费 )',
          align: 'center',
          dataIndex: 'feeStatus_dictText',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/aigoes/schoolUserInfo/list',
        delete: '/aigoes/schoolUserInfo/delete',
        deleteBatch: '/aigoes/schoolUserInfo/deleteBatch',
        exportXlsUrl: '/aigoes/schoolUserInfo/exportXls',
        importExcelUrl: 'aigoes/schoolUserInfo/importExcel',
      },
      dictOptions: {},
      superFieldList: [],
    }
  },
  created() {
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'int', value: 'authFlag', text: 'authFlag', dictCode: '' })
      fieldList.push({ type: 'date', value: 'authTime', text: 'authTime' })
      fieldList.push({ type: 'string', value: 'authSign', text: 'authSign', dictCode: '' })
      fieldList.push({ type: 'int', value: 'empower', text: 'empower', dictCode: '' })
      fieldList.push({ type: 'int', value: 'receive', text: 'receive', dictCode: '' })
      fieldList.push({ type: 'int', value: 'tenantId', text: '租户id', dictCode: '' })
      fieldList.push({ type: 'date', value: 'limitTime', text: '试用期限' })
      fieldList.push({
        type: 'int',
        value: 'feeStatus',
        text: '付费状态(0.未付费 1.已付费 )',
        dictCode: '',
      })
      this.superFieldList = fieldList
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
